import React, { useState } from "react";
import { ShowText } from "../common/ShowText";
import {
  FaBoxes,
  FaRegFileAlt,
  FaRegFileImage,
  FaRegImage,
} from "react-icons/fa";
import { ShowImgStatus } from "../common/ShowImgStatus";
import { useDispatch, useSelector } from "react-redux";
import { getImageStatusFileFetch } from "../../features/action/fetchImage";
import { setHtmlContent } from "../../features/redux/statusFileSlice";
import { fetchOrderFile } from "../../features/action/fetchStatusFile";
import { ShowOrder } from "../common/ShowOrder";
import { fetchOrderFileSH } from "../../features/action/fetchStorageFile";
import { setHtmlContentSH } from "../../features/redux/storageFileSlice";
import { Button } from "../../util/bloks";
import { putUpdateKeeper } from "../../features/action/fetchKeeper";

const StorageStatus = ({ status, isOpen, onToggle }) => {
  const { imgStatus, loadingImage } = useSelector((state) => state.imageFile);
  const { htmlContent } = useSelector((state) => state.orderFile);
  const { htmlContentSH } = useSelector((state) => state.storageFile);
  const [showItems, setShowItems] = useState(false);
  const [showText, setShowText] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const [showOrderSH, setShowOrderSH] = useState(false);
  const [number, setNumber] = useState(null);
  const [line, setLine] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const dispatch = useDispatch();

  const handleOpenText = (e, key) => {
    setMousePosition({ x: e.clientX + 25, y: e.clientY });
    setShowText(key);
  };

  const handleClickStatus = (nameStatus, id) => {
    console.log(nameStatus, id);
    //dispatch(putUpdateKeeper(id, nameStatus, number, line));
    setNumber(null);
    setLine(null);
  };

  const handleOpenImage = (key, url) => {
    console.log(url);
    setShowItems(key);
    //dispatch(getImageStatusFileFetch(url));
  };

  const handleOpenOrder = (key, numOrder) => {
    setShowOrder(key);
    dispatch(setHtmlContent(null));
    dispatch(fetchOrderFile(numOrder));
  };
  const handleOpenOrderSH = (key, numOrder) => {
    console.log(numOrder);
    setShowOrderSH(key);
    dispatch(setHtmlContentSH(null));
    dispatch(fetchOrderFileSH(numOrder));
  };

  return (
    <React.Fragment key={status._id}>
      {/* ----------------------------------------Number Order----------------------------------------------------- */}
      <div className="w-[22%] content-center">
        <div
          className="flex h-[90%]  bg-[#fd9a29] text-left  items-center rounded-r-[8px] mx-2"
          onMouseDown={(e) => handleOpenText(e, status._id)}
        >
          {/* ----------------------------------------Show TEXT----------------------------------------------------- */}
          {showText === status._id && (
            <ShowText
              text={status.client}
              setShowText={setShowText}
              mousePosition={mousePosition}
              key={status._id}
            />
          )}
          {/* --------------------------------------------------------------------------------------------- */}
          <div className="flex  w-full">
            <div className="text-left px-4">
              <p className="text-3xl font-bold text-white">{status.orderSH}</p>
            </div>
          </div>
        </div>
      </div>
      {/* --------------------------------------Status SO------------------------------------------------- */}
      {/* <button
        className="text-[2vw] text-[#dbdbdb] content-center px-2"
        onClick={() => handleOpenOrder(status._id, status.orderSO)}
      >
        <div className="flex  w-full">
          <p className="text-[1vw] font-bold text-[#dbdbdb] ">SO</p>
          <FaRegFileAlt />
        </div>
        {showOrder === status._id && (
          <ShowOrder setShowOrder={setShowOrder} htmlContent={htmlContent} />
        )}
      </button> */}

      <div className="h-[40px] w-[2px] bg-[#dbdbdb] my-auto mt-[15px]"></div>
      {/* --------------------------------------Status SH------------------------------------------------- */}
      <button
        className="text-[2vw] text-[#dbdbdb] content-center px-2"
        onClick={() => handleOpenOrderSH(status._id, status.orderSH)}
      >
        <div className="flex  w-full">
          <p className="text-[1vw] font-bold text-[#dbdbdb] ">SH</p>
          <FaRegFileAlt />
        </div>
        {showOrderSH === status._id && (
          <ShowOrder
            setShowOrder={setShowOrderSH}
            htmlContent={htmlContentSH}
          />
        )}
      </button>

      <div className="h-[40px] w-[2px] bg-[#dbdbdb] my-auto mt-[15px]"></div>
      {/* --------------------------------------Status Image------------------------------------------------- */}
      <button
        className="text-[2vw] text-[#dbdbdb] w-[4%] content-center "
        onClick={() => handleOpenImage(status._id,status.orderSO)}
      >
        <FaRegFileImage />
        {showItems === status._id && (
          <ShowImgStatus
            url={imgStatus}
            setShowItems={setShowItems}
            loadingImage={loadingImage}
          />
        )}
      </button>
      <div className="text-[2vw] text-[#dbdbdb] w-[4%] content-center ">
        <p className="h-[90%] content-center font-bold text-[2vw] border-[#dbdbdb] border-[2px] rounded-[8px] mx-1">
          {status.table
            ? status.table.filter((item) => item.check === false).length
            : 0}
        </p>
      </div>
      {/* --------------------------------------Status ALL------------------------------------------------- */}
      {/* <div className="flex flex-row items-center justify-center h-[70px] w-[20%]"></div> */}

      {/* --------------------------------------Toggle Button------------------------------------------------- */}
      <button
        className="w-[5%] content-center cursor-pointer hover:bg-gray-100 rounded"
        onClick={onToggle}
      >
        <span className="text-2xl text-[#dbdbdb]">{isOpen ? "▲" : "▼"}</span>
      </button>
      {/* --------------------------------------Status ALL------------------------------------------------- */}
      <div className="flex flex-row items-center justify-center h-[70px] w-[30%]">
          <select
            name="Line"
            onChange={(e) => setLine(e.target.value)}
            className=" h-[50%] w-[40%] px-2 mx-2 border-solid border-2 border-[#000000] outline-none text-[1vw] "
          >
            <option value="">choose an Line</option>
            <option value="LINE 1">LINE 1</option>
            <option value="LINE 2">LINE 2</option>
            <option value="Other">Other</option>
          </select>

          <input
            type="text"
            placeholder="place"
            min="0"
            step="1"
            onChange={(e) => setNumber(e.target.value)}
            className=" h-[50%] w-[40%] px-2 mx-2 border-solid border-2 border-[#000000] outline-none  "
          />
        </div>
      {Button(<FaBoxes className="text-white text-[2vw]" />, () =>
        handleClickStatus("ready", status._id)
      )}
    </React.Fragment>
  );
};

export default StorageStatus;
